import { RadioButton } from 'element-ui'

const YRadioButton = RadioButton
YRadioButton.$depends = [RadioButton]
YRadioButton.$name = 'y-radio-button'
YRadioButton._name = 'RadioButton 单选框按钮'

export default YRadioButton
